module.exports = __webpack_public_path__ + "static/media/yes.11938714.mp3";